import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const endPricingTest = {
  name: "endPricingTest" as const,
  input: z.object({ pricingTestId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
